import { useEffect, useState } from "react";
import { KeyRound, Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import CriticalPinDialog from "../CriticalPinDialog";

export default function PrivacyTab() {
    const [settings, setSettings] = useState(null);
    const [currentPin, setCurrentPin] = useState("");
    const [newPin, setNewPin] = useState("");
    const [newPin2, setNewPin2] = useState("");
    const [busy, setBusy] = useState(false);
    const [emailDraft, setEmailDraft] = useState("");
    const [pinForEmail, setPinForEmail] = useState(false);

    const load = () => api.get("/admin/settings/privacy").then((r) => { setSettings(r.data); setEmailDraft(r.data.admin_email); }).catch(() => {});
    useEffect(() => { load(); }, []);

    const changePin = async () => {
        if (newPin !== newPin2) return toast.error("Yeni şifreler eşleşmiyor");
        if (newPin.length < 6) return toast.error("Yeni şifre en az 6 karakter olmalı");
        setBusy(true);
        try {
            await api.post("/admin/settings/pin", { current_pin: currentPin, new_pin: newPin });
            toast.success("Kritik işlem şifresi güncellendi");
            setCurrentPin(""); setNewPin(""); setNewPin2("");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Değiştirilemedi");
        } finally {
            setBusy(false);
        }
    };

    const changeEmail = async (pin) => {
        setBusy(true);
        try {
            await api.post("/admin/settings/admin-email", { email: emailDraft }, { headers: { "X-Critical-Pin": pin } });
            toast.success("Admin Google hesabı güncellendi — bir sonraki girişte bu hesap admin olacak");
            setPinForEmail(false);
            load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Değiştirilemedi");
        } finally {
            setBusy(false);
        }
    };

    if (!settings) return <div className="h-48 animate-pulse rounded-2xl bg-muted" />;

    return (
        <div className="grid gap-6 lg:grid-cols-2" data-testid="privacy-tab">
            <div className="rounded-2xl border bg-card p-6 shadow-sm">
                <div className="flex items-center gap-2">
                    <KeyRound className="h-5 w-5 text-terra-600" />
                    <h3 className="font-display text-lg font-bold">Kritik İşlem Şifresi</h3>
                </div>
                <p className="mt-1 text-xs text-muted-foreground">Silme ve pasifleştirme gibi kritik işlemlerde istenen ayrı şifre. Yalnızca admin görür.</p>
                <div className="mt-4 space-y-3">
                    <Input type="password" value={currentPin} onChange={(e) => setCurrentPin(e.target.value)} placeholder="Mevcut kritik şifre" className="text-stone-400 placeholder:text-stone-300" data-testid="pin-current" />
                    <Input type="password" value={newPin} onChange={(e) => setNewPin(e.target.value)} placeholder="Yeni kritik şifre (min. 6 karakter)" className="text-stone-400 placeholder:text-stone-300" data-testid="pin-new" />
                    <Input type="password" value={newPin2} onChange={(e) => setNewPin2(e.target.value)} placeholder="Yeni kritik şifre (tekrar)" className="text-stone-400 placeholder:text-stone-300" data-testid="pin-new2" />
                    <Button onClick={changePin} disabled={busy || !currentPin || !newPin} className="bg-terra-600 hover:bg-terra-700 text-white" data-testid="pin-change-button">
                        {busy ? "Güncelleniyor..." : "Şifreyi Güncelle"}
                    </Button>
                </div>
            </div>

            <div className="rounded-2xl border bg-card p-6 shadow-sm">
                <div className="flex items-center gap-2">
                    <Mail className="h-5 w-5 text-terra-600" />
                    <h3 className="font-display text-lg font-bold">Admin Google Hesabı</h3>
                </div>
                <p className="mt-1 text-xs text-muted-foreground">Google ile girişte admin yetkisi alacak e-posta adresi. Değişiklik kritik şifre gerektirir.</p>
                <div className="mt-4 space-y-3">
                    <div className="flex items-center gap-2 rounded-lg border bg-muted/50 px-3 py-2 text-sm">
                        <ShieldCheck className="h-4 w-4 text-emerald-600" />
                        <span>Mevcut: <strong>{settings.admin_email}</strong></span>
                    </div>
                    <Input type="email" value={emailDraft} onChange={(e) => setEmailDraft(e.target.value)} placeholder="yeni-admin@gmail.com" data-testid="admin-email-input" />
                    <Button onClick={() => setPinForEmail(true)} disabled={!emailDraft.includes("@") || emailDraft === settings.admin_email} variant="outline" data-testid="admin-email-change">
                        Google Hesabını Değiştir
                    </Button>
                </div>
            </div>

            <CriticalPinDialog
                open={pinForEmail}
                onClose={() => setPinForEmail(false)}
                onSubmit={changeEmail}
                actionLabel={`Admin hesabını "${emailDraft}" olarak değiştirme`}
                busy={busy}
            />
        </div>
    );
}
